export default "__VITE_ASSET__BmSLeJTY__"